/* 
 * Copyright (C) 2022 SHC Holdings LLC.  All Rights Reserved. 
 */
import React from 'react';
import { SelectedGeographySource, PatientChoroplethLayer, ImportingLocationLayers, MapComponent, InfoPopup } from 'nmqf-common-ui';

export const IndexMapComponent: React.FC = () => {
  return (
    <MapComponent>
      <SelectedGeographySource>
        <PatientChoroplethLayer />
        <ImportingLocationLayers />
      </SelectedGeographySource>
      <InfoPopup />
    </MapComponent>
  );
};
